import { render, staticRenderFns } from "./ContentBox.vue?vue&type=template&id=bacb1512&scoped=true&"
import script from "./ContentBox.vue?vue&type=script&lang=js&"
export * from "./ContentBox.vue?vue&type=script&lang=js&"
import style0 from "./ContentBox.vue?vue&type=style&index=0&id=bacb1512&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacb1512",
  null
  
)

export default component.exports